/** `Number(null)` is 0 — treat absent / null / empty / non-finite as no bound for the form. */
function storedSalaryBoundToFormString(value) {
  if (value == null || value === "") return "";
  const n = Number(value);
  return Number.isFinite(n) ? String(n) : "";
}

/**
 * Maps stored POST /applicants/me/job-search body (from `applicant_last_job_searches`)
 * to `JobSearchPage` router `searchUiState`.
 *
 * @param {object | null | undefined} criteria
 * @returns {object | null}
 */
export function applicantLastJobSearchBodyToSearchUiState(criteria) {
  if (!criteria || typeof criteria !== "object") return null;
  const countryCodes = Array.isArray(criteria.countryCodes)
    ? criteria.countryCodes.map((c) => String(c || "").trim().toUpperCase()).filter(Boolean)
    : [];
  const keywords = Array.isArray(criteria.keywords)
    ? criteria.keywords.map((k) => String(k || "").trim()).filter(Boolean)
    : [];
  if (!countryCodes.length || !keywords.length) return null;
  const wm = String(criteria.workMode || "").trim().toLowerCase();
  const criteriaWorkMode = wm === "remote" || wm === "hybrid" || wm === "onsite" ? wm : "";
  return {
    hasSearched: true,
    criteriaCountryCodes: countryCodes,
    criteriaTitles: keywords.join(", "),
    criteriaWorkMode,
    criteriaSalaryCurrency: String(criteria.salaryCurrency || "GBP").trim().toUpperCase(),
    salaryMin: storedSalaryBoundToFormString(criteria.salaryMin),
    salaryMax: storedSalaryBoundToFormString(criteria.salaryMax),
    showNotForMe: criteria.showNotForMe !== undefined ? Boolean(criteria.showNotForMe) : true,
    showApplied: criteria.showApplied !== undefined ? Boolean(criteria.showApplied) : true,
    showSaved: criteria.showSaved !== undefined ? Boolean(criteria.showSaved) : true,
    resultsView: criteria.resultsView === "tab" ? "tab" : "list",
    executeSearchOnMount: true,
  };
}
